// extracted by mini-css-extract-plugin
export default {"popularSearches":"_c4e3ae99","popularSearchesCategory":"_61beeba9"};